import type { Customer } from '@ztechapps/common.contract'
import { UserStatusEnum } from '@ztechapps/common.contract'
import { extractEmail, generateId } from '@ztechapps/common.utils'
import type { PartialDeep } from 'type-fest'
import merge from 'lodash/merge'

export const createDefault = (newValue?: PartialDeep<Customer>): Customer => {
  const email = newValue?.profile?.email

  let defaultValue = {} as Partial<Customer>

  if (email) {
    //we need to extract the name from email so we can get correct contact name
    const emailParts = extractEmail(email)
    const name = emailParts?.contactName ?? email //fallback if does not exists

    defaultValue = {
      ...defaultValue,
      profile: {
        name,
        email,
        picture: 'https://res.cloudinary.com/tmmshauler/image/upload/v1506318907/hauler/dft-customer.jpg',
      },
      services: {
        basic: {
          picture: 'https://res.cloudinary.com/tmmshauler/image/upload/v1506318907/hauler/dft-customer.jpg',
          email,
          name,
          password: generateId(),
          username: email,
        },
      },
    }
  }

  //we just need to merge the values
  const result = merge({}, defaultValue, newValue) as unknown as Customer

  //customers that are created are always active,
  //unlike the user, which we retain as pending
  result.status = UserStatusEnum.active

  return result
}
